'use strict';

/**
* @ngdoc service
* @name tcApp.OverlayService
* @description
*/
angular.module('tcApp')
.service('OverlayService', function($log, $window, $rootScope, $timeout, $mdPanel, $templateRequest, $route,
									GlobalService, SystemRouter, shortcutkeyService, tcConstants) {
	var OverlayService = this;
	OverlayService.mdPanelRef = null;
	OverlayService.panelPosition = null;

	var overlayCtrl = function(mdPanelRef, $scope, $sce, componentName, componentData, url,
								width, height) {
		if (angular.isDefined(componentName)) {
			$scope.overlayComponent = {
				name: componentName,
				data: componentData.data
			};
		} else {
			$scope.overlayUrl = $sce.trustAsResourceUrl(url);
		}
		if (angular.isDefined(width) && (width !== '')) {
			$scope.width = width;
		}
		if (angular.isDefined(height) && (height !== '')) {
			$scope.height = height;
		}
		
		// Called on clicking the transparent overlay container, which is equivalent to clicking outside of the overlay.
		$scope.closeOverlay = function($event) {
			if ($event && $event.target && $event.target.parentNode
				&& $event.target.parentNode.classList.contains('overlayContent')
				&& angular.isDefined(mdPanelRef)) {
				mdPanelRef.close();
			}
		};

		$scope.$on('Overlay:Close', function onClose() {
			mdPanelRef.close();
		});

		$scope.$on('$routeChangeSuccess', function onRouteChangeSuccess() {
			if (angular.isDefined(mdPanelRef)) mdPanelRef.close();
		});

		$scope.$on('Overlay:DomRemoved', function onDomRemoved() {
			if (angular.isDefined(componentName)) {
				// Run unload handlers for component overlay
				$scope.$broadcast('Component:runUnloadHandlers');
			}
			// Destroy the overlay scope and child component scope(s)
			$timeout(function() {
				$scope.$destroy();
			});
		});

		$scope.$on('$includeContentLoaded', function onIncludeContentLoaded() {
			// If panelPosition is not null, update the position of the popover
			// everytime ngInclude content is reloaded
			// The popover will always be at the correct position when first loaded.
			if (OverlayService.panelPosition !== null) {
				$timeout(function() {
					if (OverlayService.mdPanelRef) {
						OverlayService.mdPanelRef.updatePosition(OverlayService.panelPosition);
					}
				});
			}
		});

		// Handle init events for specific fields types/directives to set overlay style
		var onInitEvents = function() {
			$scope.extendHeight = true;
		};

		$scope.$on('tcNumeric:Init', onInitEvents);
		$scope.$on('tcLookupContainer:Init', onInitEvents);
		$scope.$on('tcDatePopup:Init', onInitEvents);
	};

	/**
	* @ngdoc method
	* @name OverlayService#open
	* @methodOf tcApp.OverlayService
	* @description
	* Opens a component in an overlay panel
	*
	* @param {!Object=} options Specific options object that may contain the
	*     following properties:
	*
	*	- `event` - `{!Event}`: Click event to pass to the mdPanel
	*	- `componentName` - `{string}`: Component to open in the overlay
	*	- `params` - `{string}`: Request parameters to pass to the overlay component. In the format '&a=1&b=2'
	*	- `url` - `{string}`: URL to open in the overlay (Component or URL are required - Component will take precedence)
	*	- `parentComponentName` - `{string}`: Name of the component that opened the overlay.
	*										Passed as request parameter 'tkParentComponent' to the overlay component
	*	- `popoverFor` - `{string}`: show overlay as a popover for a particular item (pass item name or HTML element ID); cannot be used with popup
	*   - `popup` - `{boolean}`: show overlay as a small popup (akin to javascript alert()); cannot be used with popoverFor
	*	- `focusHandler` - `{!Function}`: Function to run that handles the focus when the overlay is closed
	*	- `onRemovingHandler` - `{!Function}`: Function to run when the overlay is being closed
	*	- `onOpenCompleteHandler` - `{!Function}`: Function to run when the overlay has finished opening
	*	- `width` - `{string}`: The width of the iframe container, for use with 'url' only
	*	- `height` - `{string}`: The height of the iframe container, for use with 'url' only
	*   - `clickOutsideToClose` - `{boolean}`: Indicates whether the overlay should close when the user clicks outside the overlay.
	*                                        Defaults to true
	*	- `asActionPanel` - `{boolean}`: Show overlay as a flyover panel similar to the action menu panel.
	*                                  Ignored if used with popoverFor or popup (those properties takes precedence), or url (must be component)
	*	- `displayTop` - `{boolean}`: If true, overlay displays centered at the top of the screen
	*									Ignored if used with popoverFor, popup, or asActionPanel (those properties takes precedence), or url (must be component)
	*/
	this.open = function(options) {
		if (!angular.isObject(options)) {
			$log.warn('Invalid overlay options');
			return;
		}
		var componentName = options.componentName;
		if ((angular.isUndefined(componentName)) && (angular.isUndefined(options.url))) {
			$log.warn('No component or URL defined for overlay');
			return;
		}
		var params = options.params || '';
		var parentComponentName = options.parentComponentName;
		var focusHandler = options.focusHandler;
		var onRemovingHandler = options.onRemovingHandler;
		var onOpenCompleteHandler = options.onOpenCompleteHandler;
		var clickOutsideToClose = angular.isDefined(options.clickOutsideToClose) ? options.clickOutsideToClose : true;

		if ((angular.isDefined(parentComponentName)) && (parentComponentName !== '')) {
			params = (params + '&tkParentComponent=' + parentComponentName);
		}
		
		params = (params + '&TSKIPBANNER=1');
		
		if ((options.asActionPanel)
			&& ((angular.isUndefined(componentName)) || (angular.isDefined(options.popoverFor)) || (options.popup))) {
				options.asActionPanel = false;
		}
		if ((options.displayTop)
			&& ((options.asActionPanel) || (angular.isDefined(options.popoverFor)) || (options.popup))) {
				options.displayTop = false;
		}

		var panelPosition = $mdPanel.newPanelPosition();
		if (angular.isDefined(options.popoverFor)) {
			panelPosition = panelPosition.relativeTo('#' + options.popoverFor)
				.addPanelPosition(
					$mdPanel.xPosition.ALIGN_END,
					$mdPanel.yPosition.ABOVE
			);

			// This is how far we need to shift the popover so the bottom tip
			// lines up with the right edge of the target element:
			// right + border-right of the :after and :before bits in overlay.scss
			var maxOffset = 45; // is there a programmatic way to do this???
			var targetWidth = $window.document.getElementById(options.popoverFor)
				.getBoundingClientRect().width;
			if (targetWidth < 1.5 * maxOffset) {
				// if bottom tip of the popover would sit past the 2/3 point of the target element,
				// center the bottom tip on the element
				panelPosition.withOffsetX((maxOffset - targetWidth / 2) + 'px');
			}
		} else if (options.asActionPanel) {
			// fixed to the right-hand side
			if (GlobalService.logonData.langDirection === tcConstants.LANG_DIRECTION.RIGHT_TO_LEFT) {
				panelPosition = panelPosition.absolute().top().start();
			} else {
			panelPosition = panelPosition.absolute().top().end();
			}
		} else if (options.displayTop) {
			panelPosition = panelPosition.absolute().top().centerHorizontally();
		} else {
			panelPosition = panelPosition.absolute().center();
		}

		var panelClass = 'tcOverlay';
		if (angular.isDefined(options.popoverFor)) {
			panelClass += ' popoverFor';
		} else if (options.popup) {
			panelClass += ' popup';
		} else if (options.asActionPanel) {
			panelClass += ' actionPanel';
		} else if (options.displayTop) {
			panelClass += ' displayTopOverlay';
		}

		var panelConfig = {
			controller: overlayCtrl,
			controllerAs: 'ctrl',
			bindToController: false,
			position: panelPosition,
			targetEvent: options.event,
			templateUrl: 'template/overlay/overlay.html',
			clickOutsideToClose: clickOutsideToClose,
			escapeToClose: true,
			focusOnOpen: true,
			trapFocus: true,
			hasBackdrop: angular.isUndefined(options.popoverFor),
			panelClass: panelClass,
			onCloseSuccess: function() {
				if (angular.isFunction(focusHandler)) {
					focusHandler(options.event);
				} else if ((angular.isDefined(options.event)) && (options.event.target)) {
					options.event.target.focus();
				} else if (angular.isDefined(options.popoverFor)) {
					if ($window.document.getElementById(options.popoverFor)) {
						$window.document.getElementById(options.popoverFor).focus();
					}
				} else {
					GlobalService.focusFirst();
				}
				OverlayService.mdPanelRef = null;
				GlobalService.onModalToggle(false);
			},
			onRemoving: function() {
				shortcutkeyService.removeKeysForContainer('.tcOverlay');
				if (angular.isFunction(onRemovingHandler)) {
					onRemovingHandler(options.event);
				}
			},
			onDomRemoved: function() {
				$rootScope.$broadcast('Overlay:DomRemoved');
			}
			,onOpenComplete: function() {
				if (angular.isFunction(onOpenCompleteHandler)) {
					onOpenCompleteHandler(options.event);
				}

			},
			locals: {
				componentName: componentName,
				url: options.url,
				width: options.width,
				height: options.height,
			},
			resolve: {}
		};
		if (options.asActionPanel) {
			var clientWidth = $window.document.body.clientWidth;
			var panelAnimation = $mdPanel.newPanelAnimation()
				.withAnimation($mdPanel.animation.SLIDE)
				.openFrom({top: 0, left: clientWidth})
				.closeTo({top: 0, left: clientWidth});
			panelConfig.animation = panelAnimation;
		}

		// Add component data and component template load promises to the resolve list
		// in order to display and position an overlay when all data we need is loaded
		if (angular.isDefined(componentName)) {
			var paramsObject = SystemRouter.urlToObject(options.params);
			// templateUrl request always uses $route TUIDs
			var templateUrl = SystemRouter.getTemplateUrl(componentName,
					paramsObject.CONTEXT ? paramsObject.CONTEXT : '', paramsObject.tkDisplayOnly, $route.current.params.TUID);
			panelConfig.resolve.componentData = function() {
				return SystemRouter.fetchComponentData(componentName, params);
			};
			panelConfig.resolve.componentTemplate = function() {
				return $templateRequest(templateUrl);
			};
		}

		$mdPanel.open(panelConfig)
		.then(function(mdPanelRef) {
			if (!mdPanelRef) return;
			OverlayService.mdPanelRef = mdPanelRef;
			OverlayService.panelPosition = panelPosition;
			// Recalculate panel position once overlay is loaded
			$timeout(function() {
				if (OverlayService.mdPanelRef) {
					OverlayService.mdPanelRef.updatePosition(panelPosition);
				}
			}, 0);

			if (mdPanelRef.panelEl) {
				GlobalService.focusFirstInElement(mdPanelRef.panelEl);
			}
		});
		GlobalService.onModalToggle(true);
	};

	/**
	* @ngdoc method
	* @name OverlayService#close
	* @methodOf tcApp.OverlayService
	* @description
	* Closes the overlay
	*/
	this.close = function() {
		if (OverlayService.mdPanelRef) {
			return OverlayService.mdPanelRef.close();
		}
	};
});
